import { useMutation } from '@tanstack/react-query';
import { api } from '../services/api';
import { th } from 'date-fns/locale';

/**
 * Mutation to create profile from website
 * @param {function} onSuccess - Callback when profile creation succeeds
 * @param {function} onError - Callback when profile creation fails
 */
export const useCreateProfile = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ websiteUrl, accessKey }) => {
      const result = await api.createProfileFromWebsite(websiteUrl, accessKey);
      if (result?.status === 'failed') {
        throw new Error('Profile creation failed');
      }
      return result;
    },
    onSuccess: (data) => {
      if (data.status === 'failed') {
        throw new Error('Profile creation failed');
      }
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Profile creation error:', error);
      if (onError) onError(error);
    },
  });
};

export const useUpdateOffering = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ offeringId, offeringData }) => {
      const result = await api.updateProfileOffering(offeringId, offeringData);
      return result;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Update offerings error:', error);
      if (onError) onError(error);
    },
  });
};

export const useUpdateProfileSummary = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async (summaryData) => {
      const result = await api.updateProfileSummary(summaryData);
      return result;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Update profile summary error:', error);
      if (onError) onError(error);
    },
  });
};

export const useDeleteOffering = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ offeringId }) => {
      const result = await api.deleteProfileOffering(offeringId);
      return result;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Delete offering error:', error);
      if (onError) onError(error);
    },
  });
};

export const useAddOffering = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async (offeringData) => {
      const result = await api.createProfileOffering(offeringData);
      return result;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Add offering error:', error);
      if (onError) onError(error);
    },
  });
};
